angular.module('createFactoryModule', ['ui.select'])

.service('createFactoryService', function($http, hostUrl, storeService, $timeout) {
	var urlPfx = '2/factndx/';
	return {
		getDefaultDatabase: getDefaultDatabase,
		getDatabaseConnectionNames: getDatabaseConnectionNames,
		getCustomers: getCustomers,
		getIndustries: getIndustries,
		createFactory: createFactory,
		getBusinessModels: getBusinessModels,
		getDays: getDays,
		getMonths: getMonths,
		getCountries: getCountries,
		getTimeZones: getTimeZones,
		getRegions: getRegions,
		getCities: getCities,
		getCurrentSiteDetails: getCurrentSiteDetails,
		getCurrentSiteDayOfWeek: getCurrentSiteDayOfWeek
	};

	function getCurrentSite() {
		var adminConfig = storeService.getState().adminConfig;
		return adminConfig.factory.id;
	}

	function getDefaultDatabase() {
		var url = hostUrl + urlPfx + getCurrentSite() + '/DefaultDatabase';
		return $http.get(url)
			.then(getDefaultDatabaseComplete)
			.catch(getDefaultDatabaseFailed);

		function getDefaultDatabaseComplete(response) {
			return response.data;
		}

		function getDefaultDatabaseFailed(error){
			return undefined;
		}
	}

	function getDatabaseConnectionNames() {
		var url = hostUrl + urlPfx + getCurrentSite() + '/DatabaseConnectionNames';
		return $http.get(url)
			.then(getDefaultDatabaseComplete)
			.catch(getDefaultDatabaseFailed);

		function getDefaultDatabaseComplete(response) {
			return response.data;
		}

		function getDefaultDatabaseFailed(error){
			return undefined;
		}
	}

	function getCustomers() {
		var url = hostUrl + '2/Dimensions/factndx/' + getCurrentSite() + '/Customers';
		return $http.get(url)
			.then(getCustomersComplete)
			.catch(getCustomersFailed);

		function getCustomersComplete(response) {
			return response.data;
		}

		function getCustomersFailed(error) {
			return [];
		}
	}

	function getIndustries() {
		var url = hostUrl + '2/Dimensions/Industries';
		return $http.get(url)
			.then(getIndustriesComplete)
			.catch(getIndustriesFailed);

		function getIndustriesComplete(response){
			return response.data;
		}

		function getIndustriesFailed(error) {
			return [];
		}
	}

	function createFactory(factoryObject) {
		var url = hostUrl + urlPfx + getCurrentSite() + '/FactoryCreation';
		return $http.put(url, factoryObject)
			.then(createFactoryComplete)
			.catch(createFactoryFailed);

		function createFactoryComplete(response){
			return response;
		}

		function createFactoryFailed(error){
			return error;
		}
	}

	function getCurrentSiteDetails() {
		var url = hostUrl + '2/factndx/' + getCurrentSite() + '/SiteDetails';
		return $http.get(url)
			.then(function getCurrentSiteComplete(response) {
				return response.data;
			})
			.catch(function getCurrentSiteFailed(error) {
				return {};
			});
	}

	function getCurrentSiteDayOfWeek(factoryNdx) {
		var url = hostUrl + '2/factndx/' + getCurrentSite() + '/FactoryControlVariables/group/Common/family/Calendar/variable/StartingDayOfWeek';
		return $http.get(url)
			.then(getFactorySettingsComplete)
			.catch(getFactorySettingsFailed);

		function getFactorySettingsComplete(response) {
			return parseInt(response.data[getCurrentSite()]);
		}

		function getFactorySettingsFailed(error) {
			return undefined;
		}
	}

	function getBusinessModels() {
		return [{'name':'Make-To-Stock'}, {'name':'Build-To-Replenish'}, {'name':'Make-To-Order'},
		        {'name':'Configured-To-Order'}, {'name':'Package-To-Order'}];
	}

	function getDays() {
		return [{'value':2, 'name':'Monday'}, {'value':1, 'name':'Sunday'}, {'value':7, 'name':'Saturday'}];
	}

	function getMonths() {
		return [{'value':0, 'name':'January'}, {'value':1, 'name':'February'},
			{'value':2, 'name':'March'}, {'value':3, 'name':'April'},
			{'value':4, 'name':'May'}, {'value':5, 'name':'June'},
			{'value':6, 'name':'July'}, {'value':7, 'name':'August'},
			{'value':8, 'name':'September'}, {'value':9, 'name':'October'},
			{'value':10, 'name':'November'}, {'value':11, 'name':'December'}];
	}

	function getCountries() {
		var url = hostUrl + '2/Geography/Countries';
		return $http.get(url)
			.then(getCountriesComplete)
			.catch(getCountriesFailed);

		function getCountriesComplete(response) {
			return response.data;
		}

		function getCountriesFailed(error) {
			return undefined;
		}
	}

	function getRegions(country) {
		if (!country || !country.countryCode) return Promise.resolve([]);
		var regionInfoURL = 'https://secure.geonames.org/search?q=' + country.countryCode + '&country=${country.countryCode}&featureCode=ADM1&featureCode=ADM2&featureCode=ADM3&type=json&username=leandna&style=FULL';
		return fetch(regionInfoURL).then(function(res) {
			return res.json();
		}).then(function(json) {
			return json.geonames;
		}).catch(function() {
			return [];
		});
	}

	function getCities(city, country, region) {
		countryParam = (country && country.countryCode )? '&countryBias='+encodeURIComponent(country.countryCode) : '';
		regionParam = region ? '&adminCode1='+encodeURIComponent(region) : '';
		var citiesURL = 'https://secure.geonames.org/search?name_startsWith=' + encodeURIComponent(city) + countryParam + regionParam + '&orderBy=relevance&cities=cities1000&type=json&username=leandna&maxRows=20&style=FULL';
		return fetch(citiesURL)
		.then(function(res) {
			return res.json();
		}).then(function(json) {
			return json.geonames;
		}).catch(function(error) {
			return [];
		});
	}

	function getTimeZones() {
		var url = hostUrl + '2/Dimensions/factndx/' + getCurrentSite() + '/TimeZones';
		return $http.get(url)
			.then(getTimeZonesComplete)
			.catch(getTimeZonesFailed);

		function getTimeZonesComplete(response) {
			return response.data;
		}
		function getTimeZonesFailed(error) {
			return [];
		}
	}
})

.controller('createFactoryCtrl', function($scope, $rootScope, $timeout, $state, createFactoryService, factorySettingService, userService, storeService, $translate) {
	var DEFAULT_DB_SERVER = 'dbserver6';
	var adminConfig = storeService.getState().adminConfig;
	$scope.newDatabaseName = '';
	$scope.conversionFactor = '';
	$scope.validForm = validForm;
	$scope.isSuperAdmin = $rootScope.authz.isSuperAdmin(adminConfig.factory.id);

	$timeout(function(){
		jQuery('li.list-group-item.selected').removeClass('selected');
		jQuery('#createFactory').addClass('selected');
	}, 0);
	var dbName = '';
	var DEFAULT_CUSTOMER_CURRENCY = 'USD';

	function getDefaultDatabase() {
		return createFactoryService.getDefaultDatabase()
			.then(function(data) {
				if (data && data.databaseName){
					$scope.databaseName = data.databaseName;
					dbName = data.databaseName;
				}
			});
	}

	function getDatabaseConnectionNames() {
		return createFactoryService.getDatabaseConnectionNames()
			.then(function(data) {
				if (data){
					$scope.databaseConnectionNames = data;
					setDefaultNewDatabaseServer();
				}
			});
	}

	function getCustomers() {
		return createFactoryService.getCustomers()
			.then(function(data) {
				if (data) {
					$scope.customers = data;
					if ($scope.customers && $scope.customers.length) {
						$scope.activeCustomer = _.find($scope.customers, { ndx: globalConfig.customer.id });
					}
				}
			});
	}

	function getIndustries() {
		return createFactoryService.getIndustries()
			.then(function(data) {
				if (data) {
					$scope.industries = data;
					if ($scope.industries.length) {
						$scope.activeIndustry = $scope.industries[0];
					}
				}
			});
	}

	function getBusinessModels() {
		$scope.businessModels = createFactoryService.getBusinessModels();
		$scope.activeBusinessModel = $scope.businessModels[0];
	}

	function getCurrencies() {
		factorySettingService.getCurrencies(adminConfig.factory.id).then(function(currencies){
			var data = [];
			if (currencies !== '') {
				data = currencies;
			}
			$scope.currencies = data;
			$scope.activeCurrency = $scope.currencies[0];
		});
	}

	function getDays() {
		$scope.days = createFactoryService.getDays();
		$scope.activeDay = $scope.days[0];
	}

	function getMonths() {
		$scope.months = createFactoryService.getMonths();
		$scope.activeMonth = $scope.months[0];
	}

	$scope.getCities = function getCities(cityName, country, region) {
		return createFactoryService.getCities(cityName, country, region)
			.then(function(c) { return $scope.cities = c; });
	};

	function getCountries() {
		return createFactoryService.getCountries()
			.then(function(countries) {
				$scope.countries = countries.map(function(c) {
					c.countryNameNormalized = c.countryName.normalize('NFD').replace(new RegExp('\\p{Diacritic}', 'gu'), '');
					return c;
				}).sort(function(a,b) {
					if (a.continentName > b.continentName) return 1;
					if (a.continentName < b.continentName) return -1;
					var nameA = a.countryNameNormalized.replace(/^The /, '');
					var nameB = b.countryNameNormalized.replace(/^The /, '');
					if (nameA > nameB) return 1;
					if (nameA < nameB) return -1;
					return 0;
				});
				$scope.activeCountry = $scope.countries.find(function(c) { return c.countryName === 'United States'; });
			});
	}

	function getTimeZones() {
		return createFactoryService.getTimeZones()
			.then(function(data) {
				if (data) {
					$scope.timeZones = data;
					if ($scope.timeZones.length) {
						$scope.activeTimeZone = $scope.timeZones[0];
					}
				}
			});
	}

	function addErrorMessage(errorContent) {
		$scope.errorMessage = errorContent;
		$timeout(function() {
			$scope.clearErrorMessage();
		}, 5000);
	}

	function setDefaultNewDatabaseServer() {
		if ($scope.databaseConnectionNames) {
			var dbserver = _.filter($scope.databaseConnectionNames, { 'databaseConnectionName': DEFAULT_DB_SERVER });

			if (dbserver.length > 0) {
				$scope.databaseConnectionName = dbserver[0].databaseConnectionName;	
			} else {
				$scope.databaseConnectionName = $scope.databaseConnectionNames[0].databaseConnectionName;	
			}	
		}
	}

	$scope.clearErrorMessage = function() {
		$scope.errorMessage = '';
	};

	$scope.toggleNewDatabase = function() {
		$scope.newDatabase = !$scope.newDatabase;
		if ($scope.newDatabase) {
			setDefaultNewDatabaseServer();
			$scope.newCustomer = true;
			$scope.customerType = 'newCust';
			$scope.databaseName = '';
		} else {
			$scope.databaseName = dbName;
			if (!$scope.showAddNewCustomer) {
				$scope.newCustomer = false;
				$scope.customerType = 'existingCust';
			}
		}
	};

	$scope.toggleNewCustomer = function() {
		$scope.newCustomer = !$scope.newCustomer;
	};

	$scope.clearForm = function() {
		$scope.newCustomerName = '';
		$scope.databaseType = 'existingDb';
		$scope.customerType = 'existingCust';
		$scope.databaseName = dbName;
		$scope.databaseConnectionName = null;
		$scope.activeCustomer = ($scope.customers && $scope.customers.length) ?
			_.find($scope.customers, { ndx: globalConfig.customer.id }) : {};
		$scope.factoryName = '';
		$scope.factoryCity = '';
		$scope.factoryRegion = '';
		$scope.stateProvince = '';
		$scope.activeCountry = $scope.countries.find(function(c) { return c.countryName === 'United States'; });
		$scope.locale = 'en_US';
		$scope.activeBusinessModel = $scope.businessModels[0];
		$scope.activeCurrency = $scope.currencies[0];
		$scope.emailSuffix = '';
		$scope.activeDay = $scope.days[0];
		$scope.activeMonth = $scope.months[0];
		$scope.conversionFactor = '';
		$scope.newDatabase = false;
		$scope.newCustomer = false;
		$scope.factoryAlias = '';
		$scope.approver = '';
	};
	
	$scope.$watch(validForm, function (formIsValid) {
		$scope.formIsValid = formIsValid;
	});

	function validForm() {
		return !$scope.createFactory.$invalid;
	}

	$scope.isCurrencySuggested = function isCurrencySuggested() {
		if (!$scope.activeCountry) return false;
		return $scope.activeCountry
			&& $scope.currencies.find(function(t) { return t.currencyCode === $scope.activeCountry.currencyCode; })
			&& $scope.activeCurrency
			&& $scope.activeCountry.currencyCode !== $scope.activeCurrency.currencyCode;
	};

	$scope.submitForm = function() {
		$scope.submitting = true;
		var factoryObj = {};
		factoryObj.newDatabase = $scope.newDatabase;
		factoryObj.databaseName = $scope.databaseName;
		factoryObj.databaseConnectionName = $scope.databaseConnectionName;
		factoryObj.newCustomer = $scope.newCustomer;
		factoryObj.customerName = $scope.newCustomer ? $scope.newCustomerName : $scope.activeCustomer.name;
		factoryObj.factoryName = $scope.factoryName;
		factoryObj.city = $scope.factoryCity;
		factoryObj.state = $scope.stateProvince;
		factoryObj.country = $scope.activeCountry.countryName;
		factoryObj.region = $scope.factoryRegion;
		factoryObj.locale = $scope.locale;
		factoryObj.industry = $scope.activeIndustry.name;
		factoryObj.businessModel = $scope.activeBusinessModel.name;
		factoryObj.currencyLocale = $scope.activeCurrency.currencyCode;
		factoryObj.emailSuffix = $scope.emailSuffix;
		factoryObj.startingDayOfWeek = $scope.activeDay.value;
		factoryObj.fiscalYearStart = $scope.activeMonth.value;
		factoryObj.factoryAlias = $scope.factoryAlias;
		factoryObj.conversionFactor = (($scope.newCustomer && DEFAULT_CUSTOMER_CURRENCY == $scope.activeCurrency.currencyCode) ||
										$scope.activeCustomer.currencyCode == $scope.activeCurrency.currencyCode) ? '1' : $scope.conversionFactor;
		factoryObj.customerCurrency = $scope.newCustomer ? DEFAULT_CUSTOMER_CURRENCY : $scope.activeCustomer.currencyCode;
		factoryObj.timezone = $scope.activeTimeZone;
		factoryObj.approver = $scope.approver;

		createFactoryService.createFactory(factoryObj)
			.then(function(response) {
				if (response.status && response.status >= 400) {
					$scope.submitting = false;
					if (response.data && response.data.error) {
						addErrorMessage(response.data.error);
					} else {
						addErrorMessage('Unexpected Server Error');
					}
				} else if (response.status && response.status == 201) {
					if (response.data && response.data.newFactoryNdx) {
						if ($scope.newCustomer) {
							userService.switchSite(response.data.newFactoryNdx, true);
						} else {
							var newSiteMsg = $translate.instant('New site {{factory}} created.', {factory: factoryObj.factoryAlias});
							$scope.sendToast(newSiteMsg, 10000);
							$scope.factoryName = '';
							$scope.factoryAlias = '';
							$scope.factoryCity = '';
							$scope.stateProvince = '';
							$scope.submitting = false;
						}
					}
				}
			});
	};

	var clearToast = null;
	$scope.sendToast = function sendToast(message, duration) {
		$timeout.cancel(clearToast);
		$scope.toastMessage = message;
		clearToast = $timeout(function() { $scope.toastMessage = ''; }, duration);
	};

	$scope.selectCity = function selectCity($item, $model, $label, $event) {
		$scope.stateProvince = $item.adminName1;
		$scope.factoryCity = $item.name;
		$scope.activeCountry = $scope.countries.find(function(c) { return c.countryCode === $item.countryCode; });
		$scope.getCities($scope.factoryCity, $scope.activeCountry, $item.adminCode1).then(function() {
			$scope.$apply();
		});
	};

	$scope.selectCurrency = function selectCurrency(currencyCode) {
		$scope.activeCurrency = $scope.currencies.find(function(c) { return c.currencyCode === currencyCode; });
	};

	$scope.showAddNewCustomer = $state.params.showAddNewCustomer && $state.params.showAddNewCustomer === '1';
	$scope.newDatabase = false;
	$scope.newCustomer = false;
	$scope.databaseType = 'existingDb';
	$scope.databaseConnectionName = null;
	$scope.customerType = 'existingCust';
	$scope.conversionFactor = 1;
	var localeParts = globalConfig.factory.locale.split('-');
	$scope.locale = [localeParts[0], localeParts[1].toUpperCase()].join('_') || 'en_US';

	var promises = [];
	promises += getDefaultDatabase();
	if ($scope.isSuperAdmin) {
		promises += getDatabaseConnectionNames();
	}
	promises += getCustomers();
	promises += getIndustries();
	promises += getBusinessModels();
	promises += getCurrencies();
	promises += getMonths();
	promises += getDays();
	promises += getCountries();
	promises += getTimeZones();

	Promise.all(promises).then(function loadDefaults() {
		createFactoryService.getCurrentSiteDetails().then(function(site) {
			if (site) {
				$scope.conversionFactor = site.conversionFactor;
				$scope.locale = site.locale;
				$scope.activeIndustry = $scope.industries.find(function(i) { return i.name === site.industryName; });
				$scope.activeBusinessModel = $scope.businessModels.find(function(i) { return i.name === site.businessModel; });
				$scope.conversionFactor = site.conversionFactor;
				$scope.emailSuffix = site.emailSuffix;
			}
		});
	
		createFactoryService.getCurrentSiteDayOfWeek().then(function(dayOfWeek) {
			$scope.activeDay = $scope.days.find(function(day) { return dayOfWeek === day.value; });
		});
	});

	$scope.regions = [];
	$scope.cities = [];
	$scope.suggestedLocale = null;
	$scope.$watch('activeCountry', function(activeCountry, _oldCountry) {
		if (activeCountry && activeCountry.languages) {
			lang = activeCountry.languages.split(',').find(function(l) { return /^[a-z]{2}(-[A-Z]{2})?$/i.test(l); });
			if (lang) {
				if (lang.length == 2) {
					lang += '_' + activeCountry.countryCode;
				}
				$scope.suggestedLocale = lang.replace('-', '_');
			}
		}
		createFactoryService.getRegions(activeCountry).then(function(regions) {
			$scope.regions = regions;
		});
	});
})
;
